import { useState } from 'react'
import BrandMark from './BrandMark'
import ThemeToggle from './ThemeToggle'

export default function AuthLayout({ title, subtitle, children, foot }) {
  return (
    <div className="auth-shell">
      <aside className="auth-aside" aria-hidden="false">
        <BrandMark size="lg" />
        <div className="auth-aside-copy">
          <h1>Hiring, streamlined.</h1>
          <p>
            TalentFlow keeps Utopia Brands recruiting in one place — roles, pipeline,
            and people.
          </p>
        </div>
        <p className="auth-aside-foot">Utopia Brands · ATS</p>
      </aside>

      <div className="auth-panel">
        <div className="auth-panel-top">
          <div className="auth-panel-brand">
            <BrandMark />
          </div>
          <ThemeToggle />
        </div>

        <div className="auth-card card">
          {title ? <h2 className="page-title">{title}</h2> : null}
          {subtitle ? <p className="auth-sub">{subtitle}</p> : null}
          {children}
        </div>

        {foot ? <div className="auth-foot">{foot}</div> : null}
      </div>
    </div>
  )
}

export function useFormState(initial = {}) {
  const [values, setValues] = useState(initial)
  const [errors, setErrors] = useState({})
  const [alert, setAlert] = useState(null)
  const [busy, setBusy] = useState(false)

  function setField(name, value) {
    setValues((prev) => ({ ...prev, [name]: value }))
    setErrors((prev) => {
      if (!prev[name]) return prev
      const next = { ...prev }
      delete next[name]
      return next
    })
  }

  return {
    values,
    setValues,
    setField,
    errors,
    setErrors,
    alert,
    setAlert,
    busy,
    setBusy,
  }
}
